import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { PerformanceAgreementQuestionnaireSubjectFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const EmptyState: React.FC<{
  subject?: PerformanceAgreementQuestionnaireSubjectFragment
}> = ({ subject }) => (
  <Box alignItems="center" gap="s8" paddingY="s2" paddingX="s8">
    <Text.Normal weight="semibold">
      {i18n.t('performance_process.agreements.agreement.question_not_answered.title')}
    </Text.Normal>
    <Text.Normal>
      {subject
        ? i18n.t('performance_process.agreements.agreement.question_not_answered.description', {
            subject: subject.fullName,
          })
        : i18n.t(
            'performance_process.agreements.agreement.question_not_answered.no_subject_description'
          )}
    </Text.Normal>
  </Box>
)
